import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
/**
 * Clone the provided actionTypeIds and return a mapping of original IDs to
 *   cloned IDs. Use this info to properly update the Workflow metadata with the
 *   correct actionTypeIds.
 *
 * See: https://git.hubteam.com/HubSpot/AutomationTeam/issues/4787
 */
export function fetchClonedCustomCodeActions(actionTypeIds) {
  return http.post(`automation/v4/actions/internal/portal-specific/definitions/batch/clone?portalId=${PortalIdParser.get()}`, {
    data: {
      inputs: actionTypeIds
    }
  });
}

/**
 * This api is to delete staged custom code actions on clicking cancel
 * See: https://git.hubteam.com/HubSpot/AutomationTeam/issues/5643
 */
export function deleteClonedCustomCodeActions(actionTypeIds) {
  return http.post('automation/v4/actions/internal/portal-specific/definitions/batch/archive', {
    data: {
      inputs: actionTypeIds
    }
  });
}
export function fetchFixedDataPassingReferences(actions, actionIdMapping) {
  return http.post('automationplatform/v1/actions/fix-references', {
    data: {
      actions,
      actionIdMapping
    }
  });
}